// @flow
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router';
import {
  Grid,
  Row,
  Col,
  Alert,
  Button,
  FormGroup,
  FormControl,
  ControlLabel
} from 'react-bootstrap';
import { Helmet } from 'react-helmet';
import Banner from '../../components/Banner';
import Header from '../../components/Header';
import { forgotPassword } from '../../actions/authentication/passwordCreators';

type Props = {
  location?: {
    query?: {
      email?: string
    }
  },
  forgotPassword: (e: string) => Promise<Object>
};

type State = {
  message: ?string,
  messageType: ?string,
  validationState: ?string,
  email: string,
  isSending?: boolean
};

class ForgotPassword extends React.Component<Props, State> {
  constructor(props) {
    super(props);
    let email = '';
    if (props.location && props.location.query && props.location.query.email) {
      email = props.location.query.email;
    }
    this.state = {
      message: undefined,
      messageType: undefined,
      validationState: undefined,
      email
    };
  }

  handleForgotPassword = () => {
    // set validation state
    const { email } = this.state;

    const validationState = email ? undefined : 'error';
    this.setState({ validationState });

    if (validationState) {
      return;
    }
    this.setState({ isSending: true });
    this.props.forgotPassword(email).then(
      response => {
        this.setState({
          message: `Reset email sent to ${email}`,
          messageType: 'success',
          email: '',
          isSending: false
        });
      },
      error => {
        this.setState({
          message: error.data.message,
          messageType: 'danger',
          isSending: false
        });
      }
    );
  };

  handleChange = event => {
    this.setState({ email: event.target.value });
  };

  render() {
    return (
      <div className="App" aria-live="polite">
        <Helmet>
          <title>Forgot Password | Campaign Targeter</title>
        </Helmet>
        <Header />
        <Banner title="Forgot Password" image="mailbox" />

        <Grid fluid>
          <Row className="section primary-background">
            <Col sm={2} md={2} mdOffset={1} lg={2} lgOffset={2}>
              <Link to="/login" className="back-link">
                &#11104; Back to Login
              </Link>
              <br />
            </Col>
            <Col sm={8} md={6} lg={4}>
              <br />
              <Row>
                <Col sm={12} className="form-input">
                  <p>
                    Enter your registered email address to reset your password.
                  </p>
                  <FormGroup
                    bsSize="lg"
                    validationState={this.state.validationState}
                  >
                    <ControlLabel htmlFor="email">Email Address</ControlLabel>
                    <FormControl
                      type="email"
                      value={this.state.email}
                      onChange={this.handleChange}
                      placeholder="Email Address"
                      name="email"
                      id="email"
                    />
                  </FormGroup>
                </Col>
              </Row>

              <Row>
                <Col sm={12}>
                  <Button
                    bsStyle="primary"
                    type="button"
                    className="relative-padding"
                    disabled={this.state.isSending}
                    onClick={this.handleForgotPassword}
                  >
                    {this.state.isSending ? 'Sending...' : 'Send'}
                  </Button>
                </Col>
              </Row>

              <br />
              {this.state.message && (
                <Alert bsStyle={this.state.messageType}>
                  {this.state.message}
                </Alert>
              )}
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    organisations: state.organisations
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      forgotPassword
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(ForgotPassword);



// WEBPACK FOOTER //
// ./src/containers/account/ForgotPassword.js